/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Po_AmendedInputs */

const en_po_amended = /** @type {(inputs: Po_AmendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amended`)
};

/**
* | output |
* | --- |
* | "Amended" |
*
* @param {Po_AmendedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_amended = /** @type {((inputs?: Po_AmendedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_AmendedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_amended(inputs)
});